import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "onboarding-modal" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = { class: "circle-bg" }
const _hoisted_4 = { class: "circle" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "external-link" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    max_width: "54.4rem",
    min_width: "30rem",
    centered: false,
    onClickOutside: _cache[0] || (_cache[0] = $event => ($options.close()))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Icon, {
                icon: "message-chat-circle",
                stroke: "var(--brand-500)",
                height: "2.4rem",
                width: "2.4rem"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Icon, {
              class: "pointer close",
              icon: "x-close",
              stroke: "var(--gray-400)",
              height: "2rem",
              width: "2rem",
              onClick: $options.close
            }, null, 8 /* PROPS */, ["onClick"]),
            _cache[1] || (_cache[1] = _createTextVNode(" This link isn't verified "))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[2] || (_cache[2] = _createTextVNode(" Make sure you trust this link before proceeding. If you don't recognize the URL ")),
            _createElementVNode("span", _hoisted_8, _toDisplayString($props.href), 1 /* TEXT */),
            _cache[3] || (_cache[3] = _createTextVNode(", close this window. "))
          ])
        ])
      ])
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, {
        small: "",
        onClick: $options.close
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode(" Close ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _createVNode(_component_Button, {
        small: "",
        primary: "",
        onClick: $options.submit
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode(" Open link ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}